<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <VpnAdd
      v-if="showAddVpnModal"
      :vpn="selectedVpn"
      @updated="
        applyFilters();
        showAddVpnModal = false;
      "
    />
    <!-- L2TP Modal -->
    <div
      class="modal fade"
      id="l2tp-vpn-settings"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="l2tp-vpn-settings-close"
            ></button>
            <div class="text-center mb-6">
              <h4 class="mb-2 text-primary">
                {{ $t("vpns.l2tp_service_settings") }}
              </h4>
            </div>
            <hr class="mx-4 my-2" />
            <div class="row">
              <div class="col-12 mb-4">
                <div class="input-group">
                  <div class="input-group-text">
                    <div>{{ $t("vpns.connect_ip") }}</div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="ipsec_left"
                    :class="{
                      'border-danger':
                        ipsec_left &&
                        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(
                          ipsec_left,
                        ) == false,
                    }"
                  />
                  <button
                    class="btn btn-success"
                    :disabled="
                      ipsec_left &&
                        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(
                          ipsec_left,
                        ) == false
                    "
                    @click="updateipsecSettings('left', ipsec_left)"
                  >
                    <i class="ti ti-check me-2"></i>
                    {{ $t("control.save") }}
                  </button>
                </div>
              </div>
              <div class="col-12 mb-4">
                <div class="input-group">
                  <div class="input-group-text">
                    <div>{{ $t("vpns.port") }}</div>
                  </div>
                  <input
                    type="number"
                    min="1000"
                    class="form-control"
                    v-model="l2tp_settings['port']"
                  />
                  <button
                    class="btn btn-success"
                    @click="updatel2tpSettings('port', l2tp_settings['port'])"
                  >
                    <i class="ti ti-check me-2"></i>
                    {{ $t("control.save") }}
                  </button>
                </div>
              </div>
              <div class="col-12 mb-4">
                <div class="input-group">
                  <div class="input-group-text">
                    <div>{{ $t("vpns.ipsec_secret") }}</div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="ipsec_secret"
                  />
                  <button
                    class="btn btn-success"
                    @click="updateipsecSettings('secret', ipsec_secret)"
                  >
                    <i class="ti ti-check me-2"></i>
                    {{ $t("control.save") }}
                  </button>
                </div>
              </div>
              <div class="col-12 mb-4">
                <div class="input-group">
                  <div class="input-group-text">
                    <div>{{ $t("vpns.server_ip") }}</div>
                  </div>

                  <input
                    type="text"
                    class="form-control"
                    v-model="l2tp_settings['local ip']"
                    :class="{
                      'border-danger':
                        l2tp_settings['local ip'] &&
                        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(
                          l2tp_settings['local ip'],
                        ) == false,
                    }"
                  />
                  <button
                    class="btn btn-success"
                    :disabled="
                      l2tp_settings['local ip'] &&
                        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(
                          l2tp_settings['local ip'],
                        ) == false
                    "
                    @click="
                      updatel2tpSettings('local ip', l2tp_settings['local ip'])
                    "
                  >
                    <i class="ti ti-check me-2"></i>
                    {{ $t("control.save") }}
                  </button>
                </div>
              </div>
              <div class="col-12 mb-4">
                <div class="input-group">
                  <div class="input-group-text">
                    <div>{{ $t("vpns.ip_range") }}</div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="l2tp_settings['ip range']"
                    @input="validateIprange"
                    :class="{
                      'border-danger':
                        l2tp_settings['ip range'] && !valid_ip_range,
                    }"
                  />
                  <button
                    class="btn btn-success"
                    :disabled="l2tp_settings['ip range'] && !valid_ip_range"
                    @click="
                      updatel2tpSettings('ip range', l2tp_settings['ip range'])
                    "
                  >
                    <i class="ti ti-check me-2"></i>
                    {{ $t("control.save") }}
                  </button>
                </div>
                <p>EX: 192.168.10.2-192.168.20.254</p>
              </div>
              <div
                class="text-warning text-center mb-4"
                v-if="l2tp_settings_updated"
              >
                {{ $t("vpns.restart_is_required_to_update_settings") }}
              </div>
              <div class="flex justify-center">
                <button
                  class="btn btn-danger"
                  :disabled="statuses.l2tp == 'inactive'"
                  @click="stopService('xl2tpd')"
                >
                  {{ $t("vpns.stop") }}
                </button>
                <button
                  class="btn btn-success ms-2"
                  :disabled="statuses.l2tp == 'active'"
                  @click="startService('xl2tpd')"
                >
                  {{ $t("vpns.start") }}
                </button>
                <button
                  class="btn btn-warning ms-2"
                  @click="restartService('xl2tpd')"
                >
                  {{ $t("vpns.restart") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /L2TP Modal -->
    <!-- PPTP Modal -->
    <div
      class="modal fade"
      id="pptp-vpn-settings"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="pptp-vpn-settings-close"
            ></button>
            <div class="text-center mb-6">
              <h4 class="mb-2 text-primary">
                {{ $t("vpns.pptp_service_settings") }}
              </h4>
            </div>
            <hr class="mx-4 my-2" />
            <div class="row">
              <div class="col-12 mb-4">
                <div class="input-group">
                  <div class="input-group-text">
                    <div>{{ $t("vpns.server_ip") }}</div>
                  </div>

                  <input
                    type="text"
                    class="form-control"
                    v-model="pptp_settings['localip']"
                    :class="{
                      'border-danger':
                        pptp_settings['localip'] &&
                        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(
                          pptp_settings['localip'],
                        ) == false,
                    }"
                  />
                  <button
                    class="btn btn-success"
                    :disabled="
                      pptp_settings['localip'] &&
                        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(
                          pptp_settings['localip'],
                        ) == false
                    "
                    @click="
                      updatepptpSettings('localip', pptp_settings['localip'])
                    "
                  >
                    <i class="ti ti-check me-2"></i>
                    {{ $t("control.save") }}
                  </button>
                </div>
              </div>
              <div class="col-12 mb-4">
                <div class="input-group">
                  <div class="input-group-text">
                    <div>{{ $t("vpns.ip_range") }}</div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="pptp_settings['remoteip']"
                    @input="validateIprange"
                    :class="{
                      'border-danger':
                        pptp_settings['remoteip'] && !valid_ip_range_pptp,
                    }"
                  />
                  <button
                    class="btn btn-success"
                    :disabled="
                      pptp_settings['remoteip'] && !valid_ip_range_pptp
                    "
                    @click="
                      updatepptpSettings('remoteip', pptp_settings['remoteip'])
                    "
                  >
                    <i class="ti ti-check me-2"></i>
                    {{ $t("control.save") }}
                  </button>
                </div>
                <p dir="ltr">
                  EX: 192.168.10.2-254,192.168.11.2-254
                </p>
              </div>
              <div
                class="text-warning text-center mb-4"
                v-if="pptp_settings_updated"
              >
                {{ $t("vpns.restart_is_required_to_update_settings") }}
              </div>
              <div class="flex justify-center">
                <button
                  class="btn btn-danger"
                  :disabled="statuses.pptp == 'inactive'"
                  @click="stopService('pptpd')"
                >
                  {{ $t("vpns.stop") }}
                </button>
                <button
                  class="btn btn-success ms-2"
                  :disabled="statuses.pptp == 'active'"
                  @click="startService('pptpd')"
                >
                  {{ $t("vpns.start") }}
                </button>
                <button
                  class="btn btn-warning ms-2"
                  @click="restartService('pptpd')"
                >
                  {{ $t("vpns.restart") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /PPTP Modal -->
    <!-- Link Modal -->
    <div class="modal fade" id="vpn-link" tabindex="-1" aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="vpn-link-close"
            ></button>
            <div class="text-center mb-6">
              <h4 class="mb-2 text-primary">
                {{ $t("vpns.mikrotik_link_scripts") }}
              </h4>
            </div>
            <hr class="mx-4 my-2" />
            <div class="row" v-if="selectedVpn">
              <div class="col-12 my-4">
                <div class="input-group">
                  <div class="input-group-text bg-warning">
                    <div>PPTP</div>
                  </div>
                  <div
                    dir="ltr"
                    class="form-control overflow-scroll whitespace-nowrap"
                  >
                    {{
                      `/interface pptp-client add name=local-radius-pptp connect-to=${ipsec_left} password=${selectedVpn.password} user=${selectedVpn.username}`
                    }}
                  </div>
                  <button
                    @click="
                      copyToClipboard(
                        `/interface pptp-client add name=local-radius-pptp connect-to=${ipsec_left} password=${selectedVpn.password} user=${selectedVpn.username}`,
                      )
                    "
                    class="btn btn-primary"
                  >
                    <i class="ti ti-clipboard me-2"></i>
                  </button>
                </div>
              </div>
              <div class="col-12">
                <div class="input-group">
                  <div class="input-group-text bg-success">
                    <div>L2TP/IPSEC</div>
                  </div>
                  <div
                    dir="ltr"
                    class="form-control overflow-scroll whitespace-nowrap"
                  >
                    {{
                      `/interface l2tp-client add connect-to=${ipsec_left} ipsec-secret=${ipsec_secret} name=local-radius-l2tp password=${selectedVpn.password} use-ipsec=yes user=${selectedVpn.username}`
                    }}
                  </div>
                  <button
                    @click="
                      copyToClipboard(
                        `/interface l2tp-client add connect-to=${ipsec_left} ipsec-secret=${ipsec_secret} name=local-radius-l2tp password=${selectedVpn.password} use-ipsec=yes user=${selectedVpn.username}`,
                      )
                    "
                    class="btn btn-primary"
                  >
                    <i class="ti ti-clipboard me-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Link Modal -->
    <div class="row p-3 gap-3">
      <div class="card card-border-shadow-success h-100 col-12 col-lg-4">
        <div
          class="card-body d-flex justify-content-between align-items-center"
        >
          <div class="card-title mb-0">
            <p class="mb-1 card-main-text ">
              {{ $t("vpns.pptp_server") }}
            </p>
            <p class="mb-0">
              <span
                v-if="statuses.pptp == 'active'"
                class="text-success fw-medium me-2 card-1-text"
                >{{ $t("vpns.running") }}</span
              >
              <span v-else class="text-danger fw-medium me-2 card-1-text">{{
                $t("vpns.stopped")
              }}</span>
              <small>{{ pptp_server_ip }}</small>
            </p>
          </div>
          <div>
            <button
              class="btn btn-outline-primary waves-effect waves-light"
              tabindex="0"
              type="button"
              @click.prevent="openPPTpSettingsModal"
            >
              <span>
                <i class="ti ti-settings"></i>
                <span class="lg:inline-block hidden">{{
                  $t("vpns.settings")
                }}</span>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="card card-border-shadow-success h-100 col-12 col-lg-4">
        <div
          class="card-body d-flex justify-content-between align-items-center"
        >
          <div class="card-title mb-0">
            <p class="mb-1 card-main-text ">
              {{ $t("vpns.l2tp_ipsec_server") }}
            </p>
            <p class="mb-0">
              <span
                v-if="statuses.l2tp == 'active'"
                class="text-success fw-medium me-2 card-1-text"
                >{{ $t("vpns.running") }}</span
              >
              <span v-else class="text-danger fw-medium me-2 card-1-text">{{
                $t("vpns.stopped")
              }}</span>
              <small>{{ l2tp_server_ip }}</small>
            </p>
          </div>
          <div>
            <button
              class="btn btn-outline-primary waves-effect waves-light"
              tabindex="0"
              type="button"
              @click.prevent="openL2tpSettingsModal"
            >
              <span>
                <i class="ti ti-settings"></i>
                <span class="lg:inline-block hidden">{{
                  $t("vpns.settings")
                }}</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :disabled:="!this.$store.getters.settings.license.active"
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    @click="openAddVpnModal"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("vpns.add_vpn_connection") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                    v-model="filters.rows"
                    @change="applyFilters"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>

              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('log_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="export_csv('log_table', 'log')"
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('log_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 550px;"
            >
              <table
                class="dt-scrollableTable table"
                id="log_table"
                style="width: 100%;"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th></th>
                    <th>#</th>
                    <th>
                      {{ $t("vpns.username") }}
                    </th>
                    <th>{{ $t("vpns.password") }}</th>
                    <th>{{ $t("vpns.ip") }}</th>
                    <th>{{ $t("vpns.service") }}</th>
                    <th>{{ $t("vpns.link") }}</th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0" v-if="!loading">
                  <tr v-for="(vpn, index) in dataList" :key="index">
                    <th>
                      <div
                        class="dropdown relative"
                        v-if="selection_array.length <= 1"
                      >
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu absolute"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li>
                            <button
                              @click="openAddVpnModal(vpn)"
                              class="dropdown-item text-primary"
                            >
                              <i class="ti ti-pencil me-2"></i
                              >{{ $t("actions.edit") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click="confirmDelete(vpn)"
                              class="dropdown-item text-danger"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <td>{{ index + 1 }}</td>
                    <td>
                      {{ vpn.username }}
                    </td>
                    <td>{{ vpn.password }}</td>
                    <td>{{ vpn.ip }}</td>
                    <td>
                      <span
                        v-if="vpn.service == 'pptpd'"
                        class="badge bg-label-danger me-1"
                        >PPTP</span
                      >
                      <span
                        v-else-if="vpn.service == 'l2tpd'"
                        class="badge bg-label-success me-1"
                        >L2TP</span
                      >
                      <span
                        v-else-if="vpn.service == '*'"
                        class="badge bg-label-info me-1"
                        >{{ $t("control.all") }}</span
                      >
                      <span v-else>{{ vpn.service }}</span>
                    </td>
                    <td>
                      <button
                        @click="openLinkVpnModal(vpn)"
                        class="btn btn-primary btn-sm"
                      >
                        <i class="ti ti-link"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
import { mapGetters } from "vuex";
import VpnAdd from "../components/modals/vpn-add.vue";
export default {
  name: "AdminsLog",
  data() {
    return {
      dataList: null,
      admins: null,
      meta: { last_page: 0 },
      loading: true,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
      },
      l2tp_settings: [],
      pptp_settings: [],
      statuses: {
        l2tp: null,
        pptp: null,
        pptp_enabled: false,
      },
      l2tp_settings_updated: false,
      pptp_settings_updated: false,
      ipsec_secret: null,
      ipsec_left: null,
      pptp_server_ip: null,
      l2tp_server_ip: null,
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      loading_overlay: false,
      showAddVpnModal: false,
      valid_ip_range: true,
      valid_ip_range_pptp: true,
      selectedVpn: null,
    };
  },
  components: {
    VpnAdd,
  },
  async created() {
    this.applyFilters();
    this.getVpnSettings();
    this.getServicesStatus();
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async applyFilters() {
      const response = await axios.get("/localvpn");
      if (response.status == 200) {
        this.dataList = response.data.data;
        this.loading = false;
      }
    },
    async confirmDelete(vpn) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text:
          this.$t("vpns.delete_vpn_connection_confirm") + ` (${vpn.username})`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("iptv.yes_delete_it"),
        cancelButtonText: this.$t("control.cancel"),
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteVpn(vpn);
        }
      });
    },
    async deleteVpn(vpn) {
      try {
        const response = await axios.post(`localvpn/delete`, vpn);
        if (response.status == 200) {
          this.applyFilters();
          this.$notify({
            text: this.$t("vpns.vpn_connection_deleted_successfully"),
            type: "success",
          });
        } else {
          this.$notify({
            text: this.$t("vpns.vpn_connection_delete_failed"),
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          text: this.$t("vpns.vpn_connection_delete_failed"),
          type: "error",
        });
      }
    },
    async getVpnSettings() {
      const response = await axios.get("localvpn/settings/l2tp");
      if (response.status == 200) {
        this.l2tp_settings = response.data.data;
        this.l2tp_server_ip = response.data.local_ip;
        this.ipsec_left = response.data.left;
      }
      const pptp_response = await axios.get("localvpn/settings/pptp");
      if (pptp_response.status == 200) {
        this.pptp_settings = pptp_response.data.data;
        this.pptp_server_ip = pptp_response.data.localip;
      }
      const ipsec_response = await axios.get("localvpn/settings/ipsec");
      if (ipsec_response.status == 200) {
        this.ipsec_secret = ipsec_response.data.secret;
      }
    },
    async getServicesStatus() {
      const response = await axios.get("services");
      if (response.status == 200) {
        this.statuses.l2tp = response.data.data.find(
          (s) => s.name == "xl2tpd",
        ).status;
        this.statuses.pptp = response.data.data.find(
          (s) => s.name == "pptpd",
        ).status;
        this.statuses.pptp_enabled = response.data.data.find(
          (s) => s.name == "pptpd",
        ).has_privileges;
        if (this.statuses.pptp_enabled == false) {
          this.$swal({
            title: "تثبيت VPN غير مكتمل",
            text: "قم بالتواصل مع الدعم الفني للاستفادة من جميع ميزات VPN.",
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "رجوع",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.back();
            }
          });
        }
      }
    },
    async updatel2tpSettings(setting, value) {
      try {
        const response = await axios.post("localvpn/settings/l2tp", {
          setting,
          value,
        });
        if (response.status == 200) {
          this.getVpnSettings();
          this.$notify({
            text: this.$t("vpns.l2tp_settings_updated_successfully"),
            type: "success",
          });
          this.l2tp_settings_updated = true;
        } else {
          this.$notify({
            text: this.$t("vpns.l2tp_settings_update_failed"),
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          text: this.$t("vpns.l2tp_settings_update_failed"),
          type: "error",
        });
      }
    },
    async updateipsecSettings(setting, value) {
      try {
        const response = await axios.post("localvpn/settings/ipsec", {
          setting,
          value,
        });
        if (response.status == 200) {
          this.getVpnSettings();
          this.$notify({
            text: this.$t("vpns.l2tp_settings_updated_successfully"),
            type: "success",
          });
          this.l2tp_settings_updated = true;
        } else {
          this.$notify({
            text: this.$t("vpns.l2tp_settings_update_failed"),
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          text: this.$t("vpns.l2tp_settings_update_failed"),
          type: "error",
        });
      }
    },
    async updatepptpSettings(setting, value) {
      try {
        const response = await axios.post("localvpn/settings/pptp", {
          setting,
          value,
        });
        if (response.status == 200) {
          this.getVpnSettings();
          this.$notify({
            text: this.$t("vpns.pptp_settings_updated_successfully"),
            type: "success",
          });
          this.pptp_settings_updated = true;
        } else {
          this.$notify({
            text: this.$t("vpns.pptp_settings_update_failed"),
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          text: this.$t("vpns.pptp_settings_update_failed"),
          type: "error",
        });
      }
    },
    async startService(service) {
      try {
        const response = await axios.post(`services/start`, {
          service: service,
        });
        if (response.status == 200) {
          this.getServicesStatus();
          this.$notify({
            text: this.$t("vpns.service_started_successfully", {
              service: service.toUpperCase(),
            }),
            type: "success",
          });
          this.l2tp_settings_updated = false;
          this.pptp_settings_updated = false;
        } else {
          this.$notify({
            text: this.$t("vpns.service_start_failed", {
              service: service.toUpperCase(),
            }),
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          text: this.$t("vpns.service_start_failed", {
            service: service.toUpperCase(),
          }),
          type: "error",
        });
      }
    },
    async restartService(service) {
      try {
        const response = await axios.post(`services/restart`, {
          service: service,
        });
        if (response.status == 200) {
          this.getServicesStatus();
          this.$notify({
            text: this.$t("vpns.service_restarted_successfully", {
              service: service.toUpperCase(),
            }),
            type: "success",
          });
          this.l2tp_settings_updated = false;
          this.pptp_settings_updated = false;
        } else {
          this.$notify({
            text: this.$t("vpns.service_restart_failed", {
              service: service.toUpperCase(),
            }),
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          text: this.$t("vpns.service_restart_failed", {
            service: service.toUpperCase(),
          }),
          type: "error",
        });
      }
    },
    async stopService(service) {
      try {
        const response = await axios.post(`services/stop`, {
          service: service,
        });
        if (response.status == 200) {
          this.getServicesStatus();
          this.$notify({
            text: this.$t("vpns.service_stopped_successfully", {
              service: service.toUpperCase(),
            }),
            type: "success",
          });
          this.l2tp_settings_updated = false;
          this.pptp_settings_updated = false;
        } else {
          this.$notify({
            text: this.$t("vpns.service_stop_failed", {
              service: service.toUpperCase(),
            }),
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          text: this.$t("vpns.service_stop_failed", {
            service: service.toUpperCase(),
          }),
          type: "error",
        });
      }
    },
    openL2tpSettingsModal() {
      var modalElement = document.getElementById("l2tp-vpn-settings");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    },
    openPPTpSettingsModal() {
      var modalElement = document.getElementById("pptp-vpn-settings");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
    async openAddVpnModal(vpn = null) {
      this.showAddVpnModal = true;
      this.selectedVpn = vpn;
      await this.$nextTick();
      var modalElement = document.getElementById("add-vpn");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddVpnModal = false;
        this.selectedVpn = null;
      });
      modalInstance.show();
    },
    async openLinkVpnModal(vpn = null) {
      this.selectedVpn = vpn;
      await this.$nextTick();
      var modalElement = document.getElementById("vpn-link");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.selectedVpn = null;
      });
      modalInstance.show();
    },
    ipToNumber(ip) {
      return ip
        .split(".")
        .reduce((acc, octet) => (acc << 8) + Number(octet), 0);
    },

    validateIprange() {
      this.valid_ip_range = true;
      this.valid_ip_range_pptp = true;
      const ipRangeRegex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}-(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
      const range = this.l2tp_settings["ip range"];
      if (range != null && range.includes("-")) {
        const [start, end] = range.split("-");
        this.valid_ip_range =
          this.ipToNumber(start) <= this.ipToNumber(end) &&
          ipRangeRegex.test(range);
      } else {
        this.valid_ip_range = false;
      }
      const pptpRemoteIpRegex = /^((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)-(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d))(,((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)-(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)))*$/;
      const range2 = this.pptp_settings["remoteip"];
      if (range2 != null) {
        this.valid_ip_range_pptp = pptpRemoteIpRegex.test(range2);
      } else {
        this.valid_ip_range_pptp = false;
      }
    },

    copyToClipboard(url) {
      // Get the text field
      var copyText = document.createElement("textarea");
      copyText.value = url;
      document.body.appendChild(copyText);
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
      this.$notify({
        text: this.$t("control.copied_to_clipboard"),
        type: "info",
      });
    },
  },
};
</script>
